import { rsBranding } from "@resourcehub/resourcehub-assets";

export default ({ strings }) => ({
    visible: true,
    blog: {
        visible: false,
        destination: "https://blog.rosettastone.com/",
        external: true,
        new_window: true,

        // Labels
        label: strings.nav_primary_blog_label
    },
    contact: {
        visible: false,
        destination: "/contact/",
        external: true,
        new_window: true,

        // Labels
        label: strings.nav_primary_contact_label
    },
    rs_logo: {
        visible: true,
        image: {
            asset_static: rsBranding.rsLogoBlackSvg,
            height: "40px",
            width: "93px",
            alt: strings.nav_primary_logo_alt
        },
        link: {
            destination: "/",
            external: false,
            new_window: false
        }
    },
    phone: {
        visible: true,
        external: false,
        new_window: false,

        // Labels
        destination: "tel:18005115689",
        label: strings.nav_primary_phone_label,
        number: strings.nav_primary_phone_number
    },
    select_language: {
        visible: true,
        external: false,
        new_window: false,

        // Labels
        language_options_featured: [
            {
                url: "/comprar-ingles/",
                title: strings.locale_en_us_label_primary,
                small: strings.locale_en_us_label_secondary
            },
            {
                url: "/comprar-italiano/",
                title: strings.locale_it_it_label_primary,
                small: strings.locale_it_it_label_secondary
            },
            {
                url: "/comprar-frances/",
                title: strings.locale_fr_fr_label_primary,
                small: strings.locale_fr_fr_label_secondary
            },
            {
                url: "/comprar-aleman/",
                title: strings.locale_de_de_label_primary,
                small: strings.locale_de_de_label_secondary
            },
            {
                url: "/comprar-espanol-espana/",
                title: strings.locale_es_es_label_primary,
                small: strings.locale_es_es_label_secondary
            }
        ],
        language_options_other: [
            {
                url: "/comprar-arabe/",
                title: strings.locale_ar_ar_label_primary,
                small: strings.locale_ar_ar_label_secondary
            },
            {
                url: "/comprar-chino/",
                title: strings.locale_zn_cn_label_primary,
                small: strings.locale_zn_cn_label_secondary
            },
            {
                url: "/comprar-holandes/",
                title: strings.locale_nl_nl_label_primary,
                small: strings.locale_nl_nl_label_secondary
            },
            {
                url: "/comprar-ingles-britanico/",
                title: strings.locale_en_gb_label_primary,
                small: strings.locale_en_gb_label_secondary
            },
            {
                url: "/comprar-filipino/",
                title: strings.locale_tl_ph_label_primary,
                small: strings.locale_tl_ph_label_secondary
            },
            {
                url: "/comprar-griego/",
                title: strings.locale_el_gr_label_primary,
                small: strings.locale_el_gr_label_secondary
            },
            {
                url: "/comprar-hebreo/",
                title: strings.locale_he_il_label_primary,
                small: strings.locale_he_il_label_secondary
            },
            {
                url: "/comprar-hindi/",
                title: strings.locale_hi_in_label_primary,
                small: strings.locale_hi_in_label_secondary
            },
            {
                url: "/comprar-irlandes/",
                title: strings.locale_ga_ie_label_primary,
                small: strings.locale_ga_ie_label_secondary
            },
            {
                url: "/comprar-japones/",
                title: strings.locale_ja_jp_label_primary,
                small: strings.locale_ja_jp_label_secondary
            },
            {
                url: "/comprar-latin/",
                title: strings.locale_ko_kr_label_primary,
                small: strings.locale_ko_kr_label_secondary
            },
            {
                url: "/comprar-coreano/",
                title: strings.locale_ko_kr_label_primary,
                small: strings.locale_ko_kr_label_secondary
            },
            {
                url: "/comprar-persa/",
                title: strings.locale_fa_ir_label_primary,
                small: strings.locale_fa_ir_label_secondary
            },
            {
                url: "/comprar-polaco/",
                title: strings.locale_pl_pl_label_primary,
                small: strings.locale_pl_pl_label_secondary
            },
            {
                url: "/comprar-portugues/",
                title: strings.locale_pt_br_label_primary,
                small: strings.locale_pt_br_label_secondary
            },
            {
                url: "/comprar-ruso/",
                title: strings.locale_ru_ru_label_primary,
                small: strings.locale_ru_ru_label_secondary
            },
            {
                url: "/comprar-espanol/",
                title: strings.locale_es_la_label_primary,
                small: strings.locale_es_la_label_secondary
            },
            {
                url: "/comprar-sueco/",
                title: strings.locale_sv_se_label_primary,
                small: strings.locale_sv_se_label_secondary
            },
            {
                url: "/comprar-turco/",
                title: strings.locale_tr_tr_label_primary,
                small: strings.locale_tr_tr_label_secondary
            },
            {
                url: "/comprar-vietnamita/",
                title: strings.locale_vi_vn_label_primary,
                small: strings.locale_vi_vn_label_secondary
            }
        ],

        select_language_label: strings.nav_primary_catalog_select_language_label,
        label: strings.nav_primary_catalog_label,
        homeschool_label: strings.nav_primary_vertical_education_homeschool_label,
        homeschool_destination: "https://www.rosettastone.com/homeschool/",
        product_title: strings.global_brand_name
    },
    sign_in: {
        visible: true,
        destination: "https://www.rosettastone.com/login",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_sign_in_label
    },
    switch_language: {
        visible: true,
        destination: "https://www.rosettastone.com/",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_switch_language
    },
    support: {
        visible: true,
        destination: "https://support.rosettastone.com/es",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_support_label
    },
    vertical_consumer: {
        visible: false,
        destination: "/",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_vertical_consumer_label
    },
    vertical_education_homeschool: {
        visible: false,
        destination: "/homeschool/",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_vertical_education_for_homeschool_label
    },
    vertical_education_primary: {
        visible: true,
        destination: "/educacion-basica/",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_vertical_education_primary_label
    },
    vertical_education_secondary: {
        visible: false,
        destination: "/estudiantes/",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_vertical_education_secondary_label
    },
    vertical_education_students: {
        visible: true,
        destination: "/estudiantes/",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_vertical_education_for_students_label
    },
    vertical_enterprise: {
        visible: true,
        destination: "/empresa/",
        external: true,
        new_window: false,

        // Labels
        label: strings.nav_primary_vertical_enterprise_label
    }
});
